import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { SoldeCompteRow, TresoEvolutionRow } from '@/lib/database.types';

export function useSoldes(entrepriseId: string | null) {
  return useQuery({
    queryKey: ['soldes', entrepriseId],
    enabled: !!entrepriseId,
    queryFn: async (): Promise<SoldeCompteRow[]> => {
      if (!entrepriseId) return [];
      const { data, error } = await supabase
        .from('v_soldes_comptes')
        .select('*')
        .eq('entreprise_id', entrepriseId)
        .order('compte_type')
        .order('intitule');
      if (error) throw error;
      return (data ?? []) as unknown as SoldeCompteRow[];
    },
  });
}

export function useTresoEvolution(entrepriseId: string | null, days = 30) {
  return useQuery({
    queryKey: ['treso_evolution', entrepriseId, days],
    enabled: !!entrepriseId,
    queryFn: async (): Promise<TresoEvolutionRow[]> => {
      if (!entrepriseId) return [];
      const cutoff = new Date(Date.now() - days * 86_400_000).toISOString().slice(0, 10);
      const { data, error } = await supabase
        .from('v_treso_evolution')
        .select('*')
        .eq('entreprise_id', entrepriseId)
        .gte('jour', cutoff)
        .order('jour');
      if (error) throw error;
      return (data ?? []) as unknown as TresoEvolutionRow[];
    },
  });
}
